import { ImageIconWithTooltip, MediaTypeIcon } from "./filters";
import iconH264RenditionPath from "@/images/icon_h264_rendition.png";
import iconH264RenditionFailedPath from "@/images/icon_h264_rendition_failed.png";
import iconH264RenditionPartiallyFailedPath from "@/images/icon_h264_rendition_partially_failed.png";
import { isEmpty } from "./funcs";
import {
  FORMAT_TYPE_M4A,
  FORMAT_TYPE_MP3,
  FORMAT_TYPE_MKV_H264_ORIGINAL,
  FORMAT_TYPE_MKV_NONH264_ORIGINAL,
  FORMAT_TYPE_MOV,
  FORMAT_TYPE_MP4_H264_ORIGINAL,
  FORMAT_TYPE_M4V_H264,
  FORMAT_TYPE_FLV,
  encoderProfilesNames,
  DATA_SIZE_UNITS,
  BYTE_MULTIPLIER
} from "@/config/constants";
import iconMkvPath from "@/images/icon_mkv.png";
import iconMovPath from "@/images/icon_mov.png";
import iconMp3Path from "@/images/icon_mp3.png";
import iconMp4Path from "@/images/icon_mp4.png";
import Popover from "react-bootstrap/Popover";
import internalSyndicationIconPath from "@/images/icon_internal_syndication.png";
import { OptionComponentWithIcon } from "@/lib/form/formik/components/controls/AutocompleteInput";

export const ENCODER_JOB_STATUS_CREATED = "created";
export const ENCODER_JOB_STATUS_CLAIMED = "claimed";
export const ENCODER_JOB_STATUS_SENT = "sent";
export const ENCODER_JOB_STATUS_IN_PROCESS = "inProcess";
export const ENCODER_JOB_STATUS_ENCODING_READY = "encodingReady";
export const ENCODER_JOB_STATUS_RECEIVED = "received";
export const ENCODER_JOB_STATUS_RECEIVED_AND_PROCESSED = "receivedAndProcessed";
export const ENCODER_JOB_STATUS_FAILED = "failed";

export const encoderJobStatusLabel = {
  [ENCODER_JOB_STATUS_CREATED]: "Waiting for Encoder",
  [ENCODER_JOB_STATUS_CLAIMED]: "Claimed by Encoder",
  [ENCODER_JOB_STATUS_SENT]: "Sent to be Encoded",
  [ENCODER_JOB_STATUS_IN_PROCESS]: "Encoding in Process",
  [ENCODER_JOB_STATUS_ENCODING_READY]: "Encoding Ready (Waiting for the File)",
  [ENCODER_JOB_STATUS_RECEIVED]: "Encoded file was Received (Almost Done)",
  [ENCODER_JOB_STATUS_RECEIVED_AND_PROCESSED]: "Done",
  [ENCODER_JOB_STATUS_FAILED]: "Failed"
};

export const encoderJobStatusLabelShort = {
  [ENCODER_JOB_STATUS_CREATED]: "Waiting",
  [ENCODER_JOB_STATUS_CLAIMED]: "Claimed",
  [ENCODER_JOB_STATUS_SENT]: "Sent",
  [ENCODER_JOB_STATUS_IN_PROCESS]: "Encoding",
  [ENCODER_JOB_STATUS_ENCODING_READY]: "Ready",
  [ENCODER_JOB_STATUS_RECEIVED]: "Received",
  [ENCODER_JOB_STATUS_RECEIVED_AND_PROCESSED]: "Done",
  [ENCODER_JOB_STATUS_FAILED]: "Failed"
};

export const renderStatusIcon = (encoderJobs) => {
  if (isEmpty(encoderJobs)) {
    return null;
  }
  /* const isH264Format */
  // Ask Dani to add format in EncoderJob Profile to switch title

  const encoderJobsStatuses = encoderJobs.map(
    (encoderJob) => encoderJob.status
  );
  const renditionHasFailed = encoderJobsStatuses.every(
    (jobstatus) => jobstatus === ENCODER_JOB_STATUS_FAILED
  );
  const renditionIsDone = encoderJobsStatuses.every(
    (jobstatus) => jobstatus === ENCODER_JOB_STATUS_RECEIVED_AND_PROCESSED
  );

  let iconPath = "";
  switch (true) {
    case renditionHasFailed === true:
      iconPath = iconH264RenditionFailedPath;
      break;
    case renditionIsDone === true:
      iconPath = iconH264RenditionPath;
      break;
    default:
      iconPath = iconH264RenditionPartiallyFailedPath;
      break;
  }
  return (
    <ImageIconWithTooltip
      iconPath={iconPath}
      overlay={
        <Popover>
          <div className="emmshint">
            <div className="title">{"H264 Encoder Renditions:"}</div>{" "}
            {/* Title is hardcoded discuss with Dani */}
            <div className="content">
              {encoderJobs.map((encoderJob) => (
                <p key={encoderJob.id}>
                  <span className="label">
                    {encoderJob?.encoderProfile?.name ||
                      encoderProfilesNames[
                        extractIdFromUri(encoderJob.encoderProfile)
                      ]}
                    {": "}
                  </span>
                  <span>{encoderJobStatusLabel[encoderJob.status]}</span>
                </p>
              ))}
            </div>
          </div>
        </Popover>
      }
      width={24}
    />
  );
};

export const renderFormatIcon = (renditions, isInstantlyAvailable) => {
  let iconPath = "";
  let tooltipMessage = "";
  renditions?.forEach((rendition) => {
    switch (rendition.type) {
      case FORMAT_TYPE_MP3:
      case FORMAT_TYPE_M4A:
        iconPath = iconMp3Path;
        tooltipMessage = "Audio";
        break;
      case FORMAT_TYPE_MKV_H264_ORIGINAL:
        iconPath = iconMkvPath;
        tooltipMessage = "MKV (H.264) Original";
        break;
      case FORMAT_TYPE_MKV_NONH264_ORIGINAL:
        iconPath = iconMkvPath;
        tooltipMessage = "MKV Original";
        break;
      case FORMAT_TYPE_MOV:
        iconPath = iconMovPath;
        tooltipMessage = "MOV Original";
        break;
      case FORMAT_TYPE_MP4_H264_ORIGINAL:
        iconPath = iconMp4Path;
        tooltipMessage = "MP4 (H.264) Original";
        break;
      case FORMAT_TYPE_M4V_H264:
        iconPath = "icon_m4v.png";
        tooltipMessage = "M4V (H.264)";
        break;
      case FORMAT_TYPE_FLV:
        // is direct upload
        iconPath = "icon_flash.png";
        tooltipMessage = "TS Original";
        break;
      default:
        break;
    }
  });

  if (!iconPath || !tooltipMessage) {
    return null;
  }

  if (isInstantlyAvailable) {
    tooltipMessage += " - Instantly Available";
  }

  return (
    <ImageIconWithTooltip
      iconPath={iconPath}
      tooltipMessage={tooltipMessage}
      width={24}
    />
  );
};

/* If a page is loaded in a new tab the history length property returns 1, so length must be more than 1 in order to go back */
// must review in different browsers as it's not consistent
export const canNavigateBack = () =>
  window.history?.length > 1 || window.history.state?.idx > 1;

export const mapSeasonsWithSeriesNameAndSyndIcon = (val) => ({
  label:
    val.type === "season" && val.series !== null
      ? `${val.series.name} - ${val.name}`
      : val.name,
  value: val["@id"],
  icon: val.internalSyndicationImport && (
    <ImageIconWithTooltip
      iconPath={internalSyndicationIconPath}
      isSingleIcon
      tooltipMessage={"Internal Syndication"}
    />
  )
});

// if we add more like these maybe we can unite them in utils file in src/lib/form/fieldUtils.js or something

export const MEDIA_AUTOCOMPLETE_PROPERTIES = [
  "title",
  "id",
  "isActive",
  "isProtected",
  "providerType",
  "providerTypeString",
  "mediaType",
  "mediaTypeString",
  "hasActiveClippingJobs",
  "renditions"
];

export function getMediaAutocompleteFieldConfig(overrides = {}) {
  const defaultApiParams = {
    "exists[deleteStatus]": false,
    "orderBy[title]": "ASC",
    use: "regular",
    properties: MEDIA_AUTOCOMPLETE_PROPERTIES
  };

  // Merge defaultApiParams with overrides.apiParams
  const apiParams = {
    ...defaultApiParams,
    ...(overrides.apiParams || {})
  };

  if (overrides.apiParams?.properties) {
    // Merge default props with those from overrides
    apiParams.properties = Array.from(
      new Set([
        ...MEDIA_AUTOCOMPLETE_PROPERTIES,
        ...overrides.apiParams.properties
      ])
    );
  } else if (!apiParams.properties) {
    // Ensure default properties is always present
    apiParams.properties = MEDIA_AUTOCOMPLETE_PROPERTIES;
  }

  return {
    name: "media",
    label: "Media",
    type: "autocompleteInput",
    resource: "media",
    isRequired: true,
    searchParamName: "title",
    autocompleteInputConfig: {
      customOptionComponent: OptionComponentWithIcon
    },
    mapInitValue: (val) => ({
      mapValue: val[overrides.name || "media"]?.["@id"],
      mapShowValue: val[overrides.name || "media"]?.title
    }),
    mapResponse: (val) => {
      return {
        label: val.title,
        value: val["@id"],
        icon: <MediaTypeIcon media={val} />,
        isActive: val.isActive
      };
    },
    ...overrides,
    apiParams
  };
}
// check isMulti assignments in formContainer
export const getBaseAutoCompleteField = (overrides = {}) => {
  const isMulti = overrides.isMulti;
  const name = overrides.name;
  let defaultParams = {
    mapInitValue: (val) => ({
      mapValue: val[name]?.["@id"],
      mapShowValue: val[name]?.name
    })
  };
  if (isMulti) {
    defaultParams = {
      multiParams: {
        propName: name
      }
    };
  }
  return {
    type: "autocompleteInput",
    searchParamName: "name",
    mapResponse: (val) => {
      return {
        label: val.name,
        value: val["@id"]
      };
    },
    ...defaultParams,
    ...overrides
  };
};

export const internalSyndicationIconColumn = {
  id: "icon",
  title: " ",
  type: "filterData",
  width: "30px",
  filterData: ({ internalSyndicationImport }) =>
    internalSyndicationImport && (
      <ImageIconWithTooltip
        iconPath={internalSyndicationIconPath}
        tooltipMessage={"Internal Syndication"}
        isSingleIcon
      />
    )
};

export const extractIdFromUri = (uri) => {
  if (typeof uri !== "string") return null;
  const parts = uri.split("/");
  // Find the last non-empty part (handles trailing slashes)
  for (let i = parts.length - 1; i >= 0; i--) {
    if (parts[i]) return parts[i];
  }
  return null;
};

export const humanizeStringValues = (key) => {
  if (!key && key !== 0) return "";
  const overrides = {
    tempError: "Temporary Error",
    autoApproved: "Auto-Approved",
    rentalPPV: "PPV"
  };
  if (overrides[key]) return overrides[key];

  // Words that should stay lowercase unless they are the first word
  const smallWords = new Set(["for"]);

  // split camelCase / snake_case / kebab-case into words and Title Case them
  return String(key)
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2") // camelCase -> space
    .replace(/[_-]+/g, " ") // snake/kebab -> space
    .split(" ")
    .filter(Boolean)
    .map((word, index) => {
      const lower = word.toLowerCase();
      if (index > 0 && smallWords.has(lower)) {
        return lower; // keep lowercase
      }
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(" ");
};

export const getAppropriateDataUnit = (bytes) => {
  const i = Math.floor(Math.log(Math.abs(bytes)) / Math.log(BYTE_MULTIPLIER));
  return DATA_SIZE_UNITS[i];
};

export const formatBytes = (
  bytes,
  decimals = 2,
  showUnitNames = true,
  forcedUnit = null
) => {
  if (bytes == null || Number.isNaN(Number(bytes))) return "";
  if (bytes === 0 || bytes === "0") {
    const valueToShow = decimals === 2 ? "0.00" : "0";
    const unit = forcedUnit ?? "B";
    return `${valueToShow}${showUnitNames ? ` ${unit}` : ""}`;
  }

  const unitIndex = forcedUnit
    ? DATA_SIZE_UNITS.indexOf(forcedUnit)
    : Math.floor(Math.log(Math.abs(bytes)) / Math.log(BYTE_MULTIPLIER));

  const i = Math.max(0, Math.min(unitIndex, DATA_SIZE_UNITS.length - 1));
  const value = Number(bytes) / Math.pow(BYTE_MULTIPLIER, i);
  return `${value.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })} ${showUnitNames ? DATA_SIZE_UNITS[i] : ""}`;
};

export const isProdENV = () => process.env.NODE_ENV === "production";
